import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9877e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Internal error ")
const _hoisted_2 = {
  key: 2,
  class: "grid m-0 mt-2"
}
const _hoisted_3 = { class: "p-0 col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3" }
const _hoisted_4 = { class: "p-0 col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3" }

import { useRoute, useRouter } from "vue-router";
import { useMutation, useSubscription } from "@vue/apollo-composable";
import gql from "graphql-tag";
import NavBar from "@/components/NavBar.vue";
import PostCard from "@/components/post/PostCard.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { loading, result, error } = useSubscription(
  gql`
    subscription getPost($uuid: uuid!) {
      post_by_pk(uuid: $uuid) {
        url
        uuid
        description
        created_at
        title
        user {
          username
          id
        }
        post_tags(order_by: { tag: { name: asc } }) {
          tag {
            name
          }
        }
        bookmarks {
          uuid
        }
      }
    }
  `,
  {
    uuid: route.params.id,
  }
);

const mutation = gql`
  mutation DeletePost($uuid: uuid!) {
    delete_comment(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_post_tag(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_bookmark(where: { post_uuid: { _eq: $uuid } }) {
      affected_rows
    }
    delete_post_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

const { mutate, onDone } = useMutation(mutation);

onDone(() => router.push(`/`));

const deletePost = () => {
  mutate({ uuid: route.params.id });
};

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NavBar),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "mt-5",
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : (_unref(result))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  label: "Return",
                  class: "p-button-plain p-button-text",
                  icon: "pi pi-angle-left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(PostCard, {
                  post: _unref(result).post_by_pk,
                  onDeleteClick: deletePost
                }, null, 8, ["post"])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})